import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyDZaD3kSJCiJTZXpZhpPQ3hKiWqTiWuIYY',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'fachnew.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'fachnew',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'fachnew.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '275030637706',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:275030637706:web:df531a5c4f3c2fd6448173',
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL ?? 'https://fachnew-default-rtdb.europe-west1.firebasedatabase.app',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
